import React, { useEffect, useState } from "react";
import { Accordion, Col, Row, Spinner, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Rating } from "react-simple-star-rating";
import {
  NetworkAxios,
  ProgramSetupAxios,
  UserActivityAxios,
  OnboardingAxios,
} from "../../API";
import ContentHeading from "../../shared/commonComponents/ContentHeading";
import CdxModal from "../../shared/modal/CdxModal";
import solutionSlice from "../../store/Gallery/solutionSlice";
import { TextAreaInput } from "../../shared/inputs";
import { ROLE } from '../../shared/Enum';
import CdxToolTip from "../../shared/CdxToolTip";

const SolutionList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const solutions = useSelector((state) => state.solutions.solutions);
  const [missionList, setMissionList] = useState([]);
  const [solutionList, setSolutionList] = useState([...solutions]);
  const userDetails = useSelector((state) => state.auth.loggedInUser);
  const [showNominationModal, setShowNominationModal] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [selectedSolution, setSelectedSolution] = useState(null);
  const [feedbackText, setFeedbackText] = useState("");
  const [updatedRatings, setUpdatedRatings] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [overallRating, setOverallRating] = useState(null);
  const [offeringRatingTypes, setOfferingRatingTypes] = useState([]);
  const [selectedMissionId, setSelectedMissionId] = useState(0);
  const [offeringRatings, setOfferingRatings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [solutionTags, setSolutionTags] = useState([]);
  const [solutionFilter, setSolutionFilter] = useState({ sortBy: 0, tag: 0 });
  const [solutionsToRate, setSolutionsToRate] = useState([]);
  const [tags, setTags] = useState([]);


  let messagePoint = { ...useSelector((state) => state.auth.messagePoint) };

  useEffect(() => {
    setIsLoading(true);
    getSolutionTags();
    // getSolutionList();
    getSolutionToRate();

    ProgramSetupAxios.get("/OfferingMission/getmissionsbyoffering/" + userDetails.offeringId)
      .then(function (response) {
        setMissionList(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [userDetails.solutionId]);

  useEffect(() => {
    getSolutionList();
  }, [selectedMissionId, solutionFilter]);

  const getSolutionList = () => {
    setIsLoading(true);
    UserActivityAxios.get(`/Solution/getsolutionlistbyofferingid/${userDetails.offeringId}/${selectedMissionId}/${userDetails.offeringUserId}/${pageNo}/${pageSize}/${solutionFilter.tag}/${solutionFilter.sortBy}`)
      .then(function (response) {
        let data = [];
        dispatch(solutionSlice.actions.setSolutionSlice(response.data));
        if (response.data.length > 0) {
          data = response.data.filter((x) => x.isSubmitted == true);
        }
        setSolutionList(data);
        setIsLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getSolutionToRate = () => {
    if (userDetails.roleId !== ROLE.coach) {
      UserActivityAxios.get(`/Solution/getsolutionstorate/${userDetails.offeringId}/${userDetails.teamId}/${userDetails.offeringUserId}`)
        .then((response) => {
          setSolutionsToRate(response.data);
        }).catch((error) => {
          console.log(error);
        });
    }
  };

  const getSolutionTags = () => {
    ProgramSetupAxios.get("/SolutionTag/getsolutiontags/" + userDetails.offeringId
    )
      .then(function (response) {
        setSolutionTags(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };


  useEffect(() => {
    ProgramSetupAxios.get(
      `OfferingRatings/offeringratings/${userDetails.offeringId}`
    )
      .then((res) => {
        //dispatch(SolutionSlice.actions.setSolutionSlice([...res.data]))
        setOfferingRatingTypes([]);
        setOfferingRatingTypes(res.data.ratingTypes);
        setOfferingRatings(
          res.data.ratings.filter((x) => x.isOverallRating !== true) || []
        );
        var temp = res.data.ratings.filter(
          (x) => x.isOverallRating === true
        )[0];
        setOverallRating(temp);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const likeSolution = (e, item) => {
    e.stopPropagation();
    let temp = JSON.parse(JSON.stringify(solutions));
    var index = temp
      .map(function (e) {
        return e.id;
      })
      .indexOf(item.id);
    temp[index]["isLiked"] = true;
    temp[index]["likeCount"] = temp[index]["likeCount"] + 1;
    setSolutionList(temp);
    dispatch(solutionSlice.actions.setSolutionSlice(temp));

    let data = {
      solutionId: item.id,
      offeringUserId: userDetails.offeringUserId,
    };

    var requestObject = {
      requestModel: data,
      message: messagePoint,
      isBackgroundJob: false,
    };

    UserActivityAxios.post("/Solution/likeSolution", requestObject)
      .then(function (response) {
        OnboardingAxios.get(`OfferingUsers/getusersbyteam/${item.teamId}`)
          .then(function (response) {
            var notificationData = [];
            let temp = response.data;
            temp.forEach((element) => {
              notificationData.push({
                offeringId: userDetails.offeringId,
                missionId: userDetails.missionId,
                activityBy: userDetails.offeringUserId,
                offeringUserId: element.id,
                teamId: element.teamId,
                notificationText: ` liked your solution.`,
                actionRoute: JSON.stringify({
                  action: "Like Solution",
                  solutionId: item.id,
                  teamId: item.teamId,
                  actionText: "View",
                }),
              });
            });
            var requestObject = {
              requestModel: notificationData,
              message: messagePoint,
              isBackgroundJob: false,
            };
            UserActivityAxios.post(
              "Notification/sendnotifications",
              requestObject
            )
              .then(function (res) { })
              .catch(function (er) {
                console.log(er);
              });
          })
          .catch(function (error) {
            console.log(error);
          });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const unLikeSolution = (e, item) => {
    e.stopPropagation();
    let temp = JSON.parse(JSON.stringify(solutions));
    var index = temp
      .map(function (e) {
        return e.id;
      })
      .indexOf(item.id);
    temp[index]["isLiked"] = false;
    if (temp[index]["likeCount"] <= 0) {
      temp[index]["likeCount"] = 0;
    } else {
      temp[index]["likeCount"] = temp[index]["likeCount"] - 1;
    }
    setSolutionList(temp);
    dispatch(solutionSlice.actions.setSolutionSlice(temp));
    let requestData = {
      message: messagePoint,
      isBackgroundJob: false,
    };
    UserActivityAxios.put(
      "/Solution/unlikeSolution/" + item.id + "/" + userDetails.offeringUserId,
      requestData
    )
      .then(function (response) { })
      .catch(function (error) {
        console.log(error);
      });
  };

  const viewSolution = (item) => {
    let requestData = {
      requestModel: {
        solutionId: item.id,
        viewedBy: userDetails.offeringUserId,
      },
      message: messagePoint,
      isBackgroundJob: false,
    };
    NetworkAxios.post("/SolutionView/viewsolution", requestData)
      .then(function (response) {
        history.push("/viewsolution/" + item.id + "/" + item.teamId);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const loadMoreSolutions = () => {
    setIsLoading(true);
    UserActivityAxios.get("/Solution/getsolutionlistbyofferingid/" + userDetails.offeringId + "/0/" + userDetails.offeringUserId + "/" + (pageNo + 1) + "/" + pageSize + "/" + solutionFilter.tag + "/" + solutionFilter.sortBy)
      .then(function (response) {
        setPageNo(pageNo + 1);
        let data = [];
        if (response.data.length > 0) {
          data = response.data.filter((x) => x.isSubmitted == true);
          setSolutionList([...solutionList, ...data]);
          dispatch(solutionSlice.actions.setSolutionSlice(data));
        }
        setIsLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const SolutionListItem = (props) => {
    return (<Col
      className="solution-item d-flex"
      key={"solution" + props.index}
      onClick={() => {
        viewSolution(props.item);
      }}
    >

      {props.item.thumbnail !== null &&
        props.item.thumbnail !== "" &&
        props.item.thumbnail !== undefined && (
          <div
            className="solutionThumbnail 1"
            style={{
              backgroundImage: `url("${props.item.thumbnail}")`,
            }}
          ></div>
        )}
      {(props.item.thumbnail === null ||
        props.item.thumbnail === "" ||
        props.item.thumbnail === undefined) && (
          <div className="solutionThumbnail 2"></div>
        )}
      <div className="solutionDetails">
        <div className="solutionName pointer">
          {props.item.solutionName.length > 55
            ? props.item.solutionName.substring(0, 55) + "..."
            : props.item.solutionName}
        </div>
        <div className="team-info">
          <div className="teamName">{props.item.teamName}</div>
          <div className="team-info-divider" />
          {userDetails && userDetails.roleId && userDetails.roleId == ROLE.coach &&
            <div className="team-total-ratings">
              <CdxToolTip
                trigger={['hover', 'focus']}
                placement="bottom-start"
                content={"Average Rating from Mission Directors"}  >
                <div className={"p-1 d-flex align-items-center gap-10 "}  >
                  {props.item.totalRating}<span className="totalRatingStar" />
                </div>
              </CdxToolTip>
            </div>
          }
        </div>

        <div className="solutionBrief">
          {props.item.shortDescription.length > 150
            ? props.item.shortDescription.substring(0, 150) + "..."
            : props.item.shortDescription}
        </div>
        <div className="likeCommentDiv">
          <div className="like-comment-wrapper">
            <div className="likeDiv">
              {props.item.isLiked && (
                <div
                  className="likeIcon"
                  onClick={(e) => {
                    unLikeSolution(e, props.item);
                  }}
                ></div>
              )}
              {!props.item.isLiked && (
                <div
                  className="unlikeIcon"
                  onClick={(e) => {
                    likeSolution(e, props.item);
                  }}
                ></div>
              )}
              <div className="likeCount">{props.item.likeCount}</div>
            </div>

            <div className="commentDiv">
              <div className="commentIcon"></div>
              <div className="commentCount">
                {props.item.commentCount}
              </div>
            </div>

          </div>
          <div className="ratingDiv" onClick={(e) => { e.stopPropagation(); userDetails.roleId == ROLE.learner && handleOpenNominationModalForLearner(props.item.id); }}>
            <CdxToolTip
              trigger={['hover', 'focus']}
              placement="top-start"
              content={"Average Rating from Participants. Please click to add/view your rating."}  >
              <div className={"p-1"} >
                <div className="ratingStar"></div>  {props.item.learnersRating}
              </div>
            </CdxToolTip>
          </div>
          <div className="commentDiv">
            <button
              className="cdx-btn" style={{ minWidth: "70px" }}
              disabled={props.item.isRated}
              onClick={(e) => { e.stopPropagation(); handleOpenNominationModalForLearner(props.item.id); }}
            >
              Rate
            </button>
          </div>
        </div >
      </div >
    </Col >
    );
  };

  const handleOpenNominationModal = (item) => {
    setErrorMsg("");
    setSelectedSolution(item);
    setShowNominationModal(true);
    setFeedbackText(item.ratingFeedback);
  };

  const [isLearnerRating, setIsLearnerRating] = useState(false);
  const handleOpenNominationModalForLearner = (solutionId) => {

    // if (userDetails.roleId == ROLE.coach)
    //   return;


    UserActivityAxios.get(
      `Solution/getsolutionbyid/${solutionId}/${userDetails.offeringUserId}`
    )
      .then((res) => {
        setIsLearnerRating(true);
        setErrorMsg("");
        setSelectedSolution(res.data);
        setShowNominationModal(true);
        setFeedbackText(res.data.ratingFeedback);

        let localTags = res.data.solutionTags.map(item => { return { id: item.id, name: item.tagName }; });

        setTags(localTags);

      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCloseNominationModal = () => {
    setIsLearnerRating(false);
    setSelectedSolution(null);
    setFeedbackText("");
    setShowNominationModal(false);
    setUpdatedRatings([]);
  };

  const handleTextAreaChange = (e) => {
    setFeedbackText(e.target.value);
  };

  const handleRating = (item, rate) => {
    var temp = [...updatedRatings];

    var index = temp.findIndex((x) => x.ratingId === item.id);

    if (index > -1) temp.splice(index, 1);

    temp.push({
      solutionId: selectedSolution.id,
      ratingId: item.id,
      maxRating: item.maxRating,
      ratingValue: (rate * item.maxRating) / 100,
    });
    setUpdatedRatings(temp);
  };

  const getRating = (item) => {
    if (selectedSolution && selectedSolution.solutionRatings.length > 0) {
      var temp = selectedSolution.solutionRatings.filter(
        (x) => x.ratingId === item.id
      );
      if (temp && temp.length > 0)
        return temp[0].value;
      else return 0;
    } else {
      return 0;
    }
  };

  const getRatingType = (item) => {
    if (selectedSolution && selectedSolution.solutionRatings.length > 0) {
      var temp = selectedSolution.solutionRatings.filter(
        (x) => x.ratingId === item.id
      );
      if (temp && temp.length > 0) return temp[0].valueText;
      else return "";
    } else {
      return "";
    }
  };

  const submitRating = () => {
    if (selectedSolution.solutionRatings.length > 0) {
      selectedSolution.solutionRatings.forEach((item) => {
        var temp = updatedRatings.find((x) => x.ratingId == item.ratingId);
        if (!temp) {
          updatedRatings.push({
            solutionId: selectedSolution.id,
            ratingId: item.ratingId,
            maxRating: item.maxRating,
            ratingValue: item.value,
          });
        }
      });
    }
    let tempList = offeringRatings.filter(x => tags.some(k => k.id == x.tagId));
    if (tempList.length > updatedRatings.length) {
      setErrorMsg("Please provide your rating for all parameters.");
      return;
    }


    updatedRatings.forEach(element => {
      if (element.ratingValue < 1) {
        element.ratingValue = element.ratingValue * 20;
      }
    });
    var data = {
      ratings: updatedRatings,
      feedback: feedbackText,
      solutionId: selectedSolution.id,
      isLearnerRating: userDetails.roleId == ROLE.coach ? false : true,
      offeringUserId: userDetails.offeringUserId
    };
    var requestObject = {
      requestModel: data,
      message: messagePoint,
      isBackgroundJob: false,
    };
    UserActivityAxios.put(`Solution/ratesolution`, requestObject)
      .then((res) => {
        handleCloseNominationModal();
        setErrorMsg("");
        setIsLoading(true);
        UserActivityAxios.get(
          `/Solution/getsolutionlistbyofferingid/${userDetails.offeringId}/${selectedMissionId}/${userDetails.offeringUserId}/${pageNo}/${pageSize}/0/0`
        )
          .then(function (response) {
            let data = [];
            if (response.data.length > 0) {
              data = response.data.filter((x) => x.isSubmitted == true);
            }
            dispatch(solutionSlice.actions.setSolutionSlice(data));
            setSolutionList(data);
            setIsLoading(false);
          })
          .catch(function (error) {
            console.log(error);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getOverallRating = (sol) => {

    if (sol.solutionRatings.length > 0) {
      let avg = sol.solutionRatings.reduce((a, b) => a + b.value, 0) / sol.solutionRatings.length;
      if (isNaN(avg))
        return 0;
      else
        return Math.round(avg * 100) / 100;
    } else
      return 0;
  };

  return (
    <>
      <div className="solutionListContainer">
        <ContentHeading
          className="contentHeadingPosition"
          title="Solutions Gallery"
        />
        <div className="galleryDesc">
          You can view your and your peers' final solutions here. All participants
          and coaches on the platform will be able to view, like, comment, and
          share your solution using the gallery. You can also filter solutions
          based on missions, views, and likes.
        </div>
        <div className="filterRow">
          <div className="missionList">
            <button className={`${selectedMissionId === 0 ? "active" : ""}`} onClick={() => setSelectedMissionId(0)}
            >
              All
            </button>
            {missionList &&
              missionList.map((item, index) => {
                return (
                  <button
                    key={"m" + index}
                    className={`${selectedMissionId === item.id ? "active" : ""}`}
                    onClick={() => setSelectedMissionId(item.id)}
                  >
                    {item.missionName}
                  </button>
                );
              })}
          </div>
          <div className="filterList">
            <div className="filterDropdown push">
              <select value={solutionFilter.tag} onChange={(e) => setSolutionFilter({ ...solutionFilter, tag: e.target.value })}>
                <option value={0}>All Tags</option>
                {solutionTags && solutionTags.map((item, index) => {
                  return (<option key={"t" + index} value={item.id}>{item.tagName}</option>);
                })}
              </select>
            </div>
            <div className="filterDropdown push">
              <select value={solutionFilter.sortBy} onChange={(e) => setSolutionFilter({ ...solutionFilter, sortBy: e.target.value })}>
                <option value={0}>Sort By</option>
                <option value={1}>Date Submitted</option>
                <option value={2}>Most Viewed</option>
                <option value={3}>Most Liked</option>
                <option value={4}>Learner Rating</option>
                <option value={5}>Coach Rating</option>
              </select>
            </div>

          </div>
        </div>
        <div className="solutionList">
          <div className="my-team-section my-2">
            {solutionsToRate.length > 0 &&
              <>
                <Accordion flush defaultActiveKey="1">
                  <Accordion.Item eventKey="1">
                    <Accordion.Button as="div">Rate Solutions</Accordion.Button>
                    <Accordion.Body className="p-0 py-3">
                      <Row>
                        {solutionsToRate.map((item, index) => {
                          return (<SolutionListItem item={item} key={"s" + index} index={index} isLearner={true} />);
                        })}
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                <hr />
              </>
            }
          </div>


          <Row>
            {solutionList &&
              solutionList.map((item, index) => {
                return <SolutionListItem index={index} item={item} key={"solution-" + index} isLearner={false} />;
              })
            }

            {
              solutionList.length == 0 &&
              <div className="galleryDesc">{isLoading ? <>Loading <Spinner animation="border" className="ms-2" variant="primary" size="sm" /></>
                :
                <span><i>Solution not submitted by any team yet!</i></span>
              }</div>
            }
          </Row>

          <div className="loadMore" onClick={loadMoreSolutions}></div>
        </div>
      </div>
      <CdxModal
        show={showNominationModal}
        onHide={handleCloseNominationModal}
        animation={false}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="nominate-solution-modal"
      >
        <CdxModal.Header
          onClose={handleCloseNominationModal}
          style={{ paddingTop: "10px" }}
          noBorder={true}
          className="rating-modal-header"
        >
          {selectedSolution && (
            <div className="rating-header-wrapper w-100">
              {
                <div className="rating-header title">
                  {selectedSolution.solutionName}, <a className="team-name">{selectedSolution.teamName}</a>
                </div>
              }
            </div>
          )}
        </CdxModal.Header>
        <CdxModal.Body className="rating-body ">
          {overallRating && selectedSolution && (
            <>
              <div className="overall-rating-div">
                {overallRating && (
                  <div className="ratings-info">
                    <div className="d-flex">
                      {overallRating.name} Rating:
                      <div className="type">
                        {selectedSolution.overallRating}
                      </div>
                    </div>
                    <div className="ratings">
                      <Rating
                        initialValue={
                          getOverallRating(selectedSolution)
                        }
                        iconsCount={selectedSolution.maxRating}
                        fillColor="#00FFCA"
                        size={20}
                        allowFraction={true}
                        readonly
                      />
                      <div className="d-flex">
                        {" "}
                        <div className="value">
                          {getOverallRating(selectedSolution)}
                        </div>
                        /{selectedSolution.maxRating}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="rating-section">
                {tags && tags.map((item, index) => {
                  return (<>
                    <div className="tag-item" key={"tag-" + index}>
                      <div className="tag-name">{item.name}</div>
                      <Row className="star-rows">
                        {offeringRatings &&
                          offeringRatings.filter(x => x.tagId === item.id).map((item, index) => {
                            let newRate = updatedRatings.find(x => x.ratingId == item.id);
                            let newType = newRate && offeringRatingTypes.find(x => x.sortOrder == newRate.ratingValue);
                            let newLabel = newType && newType.name;

                            return (
                              <Col key={index} sm={6} className="mb-2">
                                <div className="ps-2 mb-1">{item.name}*</div>
                                <div className="start-background">
                                  <div className="">
                                    <Rating
                                      onClick={(value) => {
                                        handleRating(item, value);
                                      }}
                                      initialValue={getRating(item)}
                                      iconsCount={item.maxRating}
                                      fillColor="#00FFCA"
                                      size={18}
                                    />
                                  </div>

                                  <span className="rateTextValue">
                                    <nobr>{newLabel && newLabel || getRatingType(item)}</nobr>
                                  </span>
                                </div>
                              </Col>
                            );
                          })}
                      </Row>
                    </div>
                  </>
                  );
                })}
              </div>
              {/* <div className="rating-section">
                <Row className="star-rows">

                  {offeringRatings &&
                    offeringRatings.map((item, index) => {
                      let newRate = updatedRatings.find(x => x.ratingId == item.id);
                      let newType = newRate && offeringRatingTypes.find(x => x.sortOrder == newRate.ratingValue);
                      let newLabel = newType && newType.name;

                      return (
                        <Col key={index} sm={6} className="mb-2">
                          <div className="ps-2 mb-1">{item.name}*</div>
                          <div className="start-background">
                            <div className="">
                              <Rating
                                onClick={(value) => {
                                  handleRating(item, value);
                                }}
                                initialValue={getRating(item)}
                                iconsCount={item.maxRating}
                                fillColor="#00FFCA"
                                size={18}
                              />
                            </div>

                            <span className="rateTextValue">
                              <nobr>{newLabel && newLabel || getRatingType(item)}</nobr>
                            </span>
                          </div>
                        </Col>
                      );
                    })}
                </Row>
              </div> */}

              {isLearnerRating && <TextAreaInput
                label="Feedback"
                id="feedback"
                name="feedback"
                rows="3"
                value={feedbackText}
                maxLength="200"
                placeholder="Write your text here..."
                className="rating-feedback"
                onChange={handleTextAreaChange}
              />}
            </>
          )}
        </CdxModal.Body>
        {isLearnerRating && <CdxModal.Footer className="rating-footer">
          {errorMsg && (
            <span style={{ color: "red", textAlign: "right" }}>{errorMsg}</span>
          )}
          <button className="cdx-btn" onClick={submitRating}>
            {selectedSolution && selectedSolution.solutionRatings.some(x => x.offeringUserId == userDetails.offeringUserId) ? "Update"
              : "Submit"}
          </button>
        </CdxModal.Footer>}
      </CdxModal>
    </>
  );
};

export default SolutionList;
